import React from 'react';

export default function SubmitButton({ loading, text, disabled, color, grey, classAdded }) {
  return (
    <div className="k-submit animate__animated animate__fadeInUp">
      <button
        type="submit"
        disabled={loading || disabled}
        className={loading ? 'k-loading-button' : classAdded}
        style={{ backgroundColor: grey ? '#DCDCDC' : color }}
      >
        {text || 'Continue'}
      </button>
    </div>
  );
}
